(function () {
  function initTimeline(section) {
    const rows = Array.prototype.slice.call(section.querySelectorAll('.pf-tl__row'));
    const fills = Array.prototype.slice.call(section.querySelectorAll('.pf-tl__fill'));
    const brain = section.querySelector('.pf-tl__brain');
    if (rows.length === 0) return;

    function open(index) {
      rows.forEach(function (row) {
        const match = parseInt(row.getAttribute('data-index'), 10) === index;
        row.classList.toggle('is-open', match);
        const head = row.querySelector('.pf-tl__rowhead');
        if (head) head.setAttribute('aria-expanded', match ? 'true' : 'false');
      });

      let fullActive = false;
      fills.forEach(function (fill) {
        const match = parseInt(fill.getAttribute('data-index'), 10) === index;
        fill.classList.toggle('is-active', match);
        if (match && fill.classList.contains('pf-tl__fill--full')) fullActive = true;
      });
      if (brain) brain.classList.toggle('is-full-active', fullActive);
    }

    rows.forEach(function (row) {
      const head = row.querySelector('.pf-tl__rowhead');
      if (!head) return;
      head.addEventListener('click', function () {
        open(parseInt(row.getAttribute('data-index'), 10));
      });
    });
  }

  document.querySelectorAll('.pf-tl').forEach(initTimeline);

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.pf-tl');
    if (section) initTimeline(section);
  });

  document.addEventListener('shopify:block:select', function (e) {
    const row = e.target.closest('.pf-tl__row');
    const section = e.target.closest('.pf-tl');
    if (!row || !section) return;
    const head = row.querySelector('.pf-tl__rowhead');
    if (head) head.click();
  });
})();
